import { Directive, OnInit, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { SortableColumnService } from './sortableColumn.service';

@Directive({
  selector: '[sortable-table]'
})
export class SortableTableDirective implements OnInit, OnDestroy {

    // <table sortable-table (sorted)="onSorted($event)" class="table ... ... ..."
    @Output()
    sorted = new EventEmitter();

    // Coincide con el atributo de la tabla en el html:
    private columnSortedSubscription: Subscription;

  constructor(private sortService: SortableColumnService) {}

    ngOnInit() {
        // Se escucha cuando se ejecuta la función "columnSorted" del servicio.
        this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(event => {
            // console.log('->-> subscribe de sortable-table: ');
            // console.log(event);

            // Se dispara el emit que lanza en este ejemplo la función "onSorted" indicada en el html
            // y a la que se le pasa como parámetro este "event".
            this.sorted.emit(event);
        });
    }

    ngOnDestroy() {
        this.columnSortedSubscription.unsubscribe();
    }
}
